import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const inicializarDropzonePlaneaciones = () => {
  console.log("Inicializando Dropzone Planeaciones...");
};

const inicializarDropzoneEvidencias = () => {
  console.log("Inicializando Dropzone Evidencias...");
};

const initializeConsultarDocentes = () => {
  console.log("Inicializando consulta de docentes...");
};

export default function MenuLogica() {
  const location = useLocation();

  useEffect(() => {
    // Manejo de submenús (toggle)
    const botones = document.querySelectorAll('.submenu-btn');
    botones.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const submenu = btn.nextElementSibling;
        const arrow = btn.querySelector('.arrow');
        if (submenu && submenu.classList.contains('submenu-items')) {
          submenu.classList.toggle('open');
          arrow?.classList.toggle('rotate');
          submenu.style.display = submenu.classList.contains('open') ? 'flex' : 'none';
        }
      });
    });

    // === Scripts que se cargan según la ruta ===
    const ruta = location.pathname;

    const cargarScript = (src, callback = null) => {
      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      if (callback) script.onload = callback;
      document.body.appendChild(script);
    };

    // Registrar planeaciones y evidencias con Dropzone
    if (ruta.includes('registrar-planeaciones')) {
      cargarScript('https://cdnjs.cloudflare.com/ajax/libs/dropzone/5.9.3/min/dropzone.min.js', () => {
        cargarScript('/js/dropzone-planeaciones.js', () => {
          setTimeout(() => {
            if (typeof inicializarDropzonePlaneaciones === 'function') {
              inicializarDropzonePlaneaciones();
            }
          }, 100);
        });
      });
    }

    if (ruta.includes('registrar-evidencias')) {
      cargarScript('https://cdnjs.cloudflare.com/ajax/libs/dropzone/5.9.3/min/dropzone.min.js', () => {
        cargarScript('/js/dropzone-configuracion.js', () => {
          setTimeout(() => {
            if (typeof inicializarDropzoneEvidencias === 'function') {
              inicializarDropzoneEvidencias();
            }
          }, 100);
        });
      });
    }



    if (ruta.includes('consultar-alumnos')) {
      cargarScript('/js/consultar-alumnos.js');
    }



    if (ruta.includes('consultar-planeaciones')) {
      cargarScript('/js/PanelCartas.js');
    }

    if (ruta.includes('consultar-evidencias')) {
      cargarScript('/js/PanelCartas.js');
    }

    if (ruta.includes('consultar_calificaciones')) {
      cargarScript('/js/consultar_calificaciones.js');
    }

    if (ruta.includes('consultar_horarios')) {
      cargarScript('/js/consultarHorarios.js');
    }

    return () => {
      // Puedes limpiar si hay lógica que debas remover aquí
    };
  }, [location.pathname]);

  return null;
}
